import passwordService from './../../../services/password';
import mixin from "../../../mixins/mixin";


export default {

    data() {
        return {
            user: {
                token: this.$route.params.token,
                email: this.$route.params.email,
                password: null,
                password_confirmation: null,
            },
          smallLoading: false
        };
    },
    components: {
      VLoading : require('components/loading/loading.vue'),
      VInputPassword: require("components/password-input/VueInputPassword.vue"),
    },
    mixins:[mixin],
    methods: {
        async submit_reset(user) {
            this.smallLoading = true;
            await passwordService.reset(user, this);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/password/reset/reset.js